// NPM
/* Load npm scripts here */

// VENDOR
/* Load vendor modules here */
import { flowBoxTags } from 'vendor/flowbox/flowbox-tags';

// BUNDLES
/* Load bundles here */
import defaultBundle from 'bundles/default.bundle';

// HELPERS
/* Load helpers here */
import { initFiltering } from 'helpers/filters/filters';
import { wishlistHandler } from 'helpers/wishlist/wishlist';

// COMPONENTS
/* Load components here */
import { attributeInfoPopup } from 'components/attribute-info-popup/attributeInfoPopup';
import { AlertB2BPricing } from '../category-sub/partials/alert-b2b-pricing.js';

// PAGE
/* load page specific scripts */
import { ContactForm } from 'components/contact-form/contact-form';

flowBoxTags.init();

// init the default bundle
defaultBundle();
ContactForm.init();

// Init wishlist add/remove product handler
wishlistHandler.init();

// init filtering
initFiltering({
    filterType: 'search'
});

// Init filter info popups
attributeInfoPopup.init();

// B2B Pricing alert
AlertB2BPricing.init();
